import "./style.css";
import { initApp } from "./ui/app.js";

initApp();
